module.exports = __webpack_public_path__ + "img/logo.b36a3ebb.png";